import angular from 'angular';
import reportPackageGeneratedPackage from './reportPackageGeneratedPackage';
import directive from './report-package-generated-packages.directive';
import controller from './report-package-generated-packages.controller';

export default angular
  .module('app.components.reports.packageReports.reportPackageGeneratedPackages', [reportPackageGeneratedPackage])
  .directive('prReportPackageGeneratedPackages', directive)
  .controller('PRReportPackageGeneratedPackagesController', controller).name;

console.log('app.components.reports.packageReports.reportPackageGeneratedPackages created');
